import { Users } from './users';

export class ServiceLocations {
	Id?: number;
	ClientId?: number;
	PrimaryContactUserId?: number;
	Name?: string;
	Notes?: string;
	Address1?: string;
	Address2?: string;
	City?: string;
	State?: string;
	Zip?: string;
	Phone?: string;
	Fax?: string;
	Country?: string;
	WeatherZip?: string;
	PhoneSystem?: any;
	InstallationNotes?: string;
	PreviousInstallerId?: number;

	PrimaryContactUser?: Users;
	players?: any[];
	holdCount?: number;
	videoCount?: number;
	posterCount?: number;
	radioCount?: number;
	webCount?: number;
	videoWallCount?: number;
	isRepaired?: boolean;
	holdUnit?: string;
	holdRemoteNumber?: string;
	isSelected?: boolean;
	name?: string;
}
